import React from 'react';

// Style
import "./Menu.scss";

// Redux connect
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'lib/hooks/useDispatch';

// Components
import Column from './Column';
import { EmptyList } from './EmptyList';

// Type
import { TreeNode } from 'pages/Thesaurus/Thesaurus';

const dataTypeLibs = [
	{
		name: 'Signaling Pathways and Protein Classes Related Libraries',
		url: '/libraries?anchor=signaling',
	},
	{
		name: 'Disease Related Compound Libraries',
		url: '/libraries?anchor=diseases',
	},
	{
		name: 'Bioactive Screening Compound Libraries',
		url: '/libraries?anchor=screening',
	},
	{
		name: 'Drug Repurposing and Related Libraries',
		url: '/libraries?anchor=drug'
	}
];

// Interface
interface IMenu {
	template?: string;
	categoriesMenu?: TreeNode[];
}

export const configMenuProducts = (data: TreeNode[]) => [
	{
		src: '',
		calcNumber: 0.3,
		link: '/libraries',
		alt: 'Icon image 1',
		data: dataTypeLibs,
		title: 'Libraries'
	},
	{
		link: '/categorized-products',
		src: '',
		calcNumber: 0.7,
		alt: 'Icon image 2',
		data: data,
		title: 'Categorized products'
	},
	{
		link: '/impurities',
		src: '',
		calcNumber: 0.9,
		alt: 'Icon image 3',
		data: [],
		title: 'Drugs and impurities'
	},
	{
		link: '/chemical-probes',
		calcNumber: 1.2,
		src: '',
		alt: 'Icon image 4',
		data: [],
		title: 'Chemical probes'
	}
];

export const Menu: React.FC<IMenu> = (props) => {
	const { categoriesMenu = [], template = '' } = props;
	let list: React.ReactNode = <></>;

	const {
		diseases,
		bioActive,
		drugRepurposing,
		signalingPathways
	} = useAppSelector(
		(store) => {
			return {
				diseases: store.libraries.diseases,
				bioActive: store.libraries.bioActive,
				drugRepurposing: store.libraries.drugRepurposing,
				signalingPathways: store.libraries.signalingPathways
			};
		},
		shallowEqual
	);

	const isEmpty = !signalingPathways.length &&
		!drugRepurposing.length &&
		!bioActive.length;

	const configMenuLibraries = [
		{
			src: 'iconMenu1',
			calcNumber: 0.3,
			alt: 'Icon image 1',
			titleId: 'signaling',
			data: signalingPathways,
			title: 'Signaling Pathways and Protein Classes Related Libraries'
		},
		{
			src: 'iconMenu2',
			calcNumber: 0.7,
			titleId: 'screening',
			alt: 'Icon image 2',
			data: bioActive,
			children: {
				data: diseases,
				calcNumber: 0.7,
				src: 'iconMenu4',
				alt: 'Icon image 4',
				titleId: 'diseases',
				title: 'Disease Related Compound Libraries'
			},
			title: 'Bioactive Screening Compound Libraries'
		},
		{
			titleId: 'drug',
			calcNumber: 0.9,
			src: 'iconMenu3',
			alt: 'Icon image 3',
			data: drugRepurposing,
			title: 'Drug Repurposing and Related Libraries'
		}
	];

	if (isEmpty) {
		return <EmptyList />;
	}

	if(template === 'products') {
		list = configMenuProducts(categoriesMenu)?.map((item: any, i) => {
			return <Column
				isProducts
				src={item.src}
				alt={item.alt}
				link={item.link}
				data={item.data}
				title={item.title}
				imgClass="menu__img"
				titleClass="menu__title"
				key={`${item.title}_${i}`}
				linkClass="menu__list-item"
				calcNumber={item.calcNumber}
				imgArrowClass="menu__list-item-arrow"
				ulClass="menu__col menu__products-col flex-direction-column"
				wrapperClass="menu__col flex flex-ai-start flex-direction-column"
			/>;
		});
	}

	if(template === 'libraries') {
		list = configMenuLibraries.map((item, i) => {
			return <Column
				src={item.src}
				alt={item.alt}
				data={item.data}
				title={item.title}
				imgClass="menu__img"
				titleId={item.titleId}
				titleClass="menu__title"
				key={`${item.title}_${i}`}
				linkClass="menu__list-item"
				calcNumber={item.calcNumber}
				children={item?.children || {}}
				imgArrowClass="menu__list-item-arrow"
				ulClass="menu__col flex-direction-column"
				wrapperClass="menu__col flex flex-ai-start flex-direction-column"
			/>;
		});
	}

	return <nav className="menu flex flex-jc-between flex-ai-start wrapper">
		{list}
	</nav>;
};

export default Menu;